module.exports = __webpack_public_path__ + "img/Minstry_Updates_Desktop.jpg";